import { Navigate, useLocation } from 'react-router-dom';
// Utils
import { useAppContext } from '../store/AppContext';
import hasPermission from '../permissions/hasPermission';

/**
 * ProtectedRoute component.
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {Array<string>} [props.permissions]
 * @returns {React.ReactNode} The children if permission is granted,
 * otherwise a Navigate component redirecting to the home page.
 */
export default function ProtectedRoute({ permissions = [], children }) {
  // Hooks
  const location = useLocation();
  const [{ auth, user }] = useAppContext();

  return !!auth?.token && hasPermission(permissions, user?.permissions)
    ? children
    : <Navigate to="/login" state={{ from: location }} replace />;
}
